import { createRequestActions as request } from 'store/actionCreators'
import { createAction } from 'redux-actions'

export const setStory = request('ACTIVITY/SET_STORY', ({ activityId, story, mentions, userActivityId }) => ({
  request: {
    url: '/activities-users-stories',
    method: 'POST',
    data: {
      activityId,
      story,
      mentions,
      userActivityId,
    },
  },
}))

export const setHasStory = createAction('ACTIVITY/SET_HAS_STORY', (data: object) => {
  return data
})

export const setEditStory = createAction('ACTIVITY/SET_EDIT_STORY', (data: object) => {
  return data
})
